const checkDomain = (domains) => {
    return domains.some(domain => globalThis.location?.hostname?.includes(domain));
};

export const isLowside = () => {
    return checkDomain(["localhost", "saberdevusa.xyz", "saberastro.com", "spacecockpit.space", "saber-sbms.basec.io"]);
}

export const INDIVIDUAL_HEADER_HEIGHT = 16;
export const OPT_HEADER_HEIGHT = (exercise, includeExerciseData, motds) => {
    let height = 0;
    if(exercise) height += INDIVIDUAL_HEADER_HEIGHT;
    if(includeExerciseData) height += INDIVIDUAL_HEADER_HEIGHT;
    if(motds?.length) height += motds.length * INDIVIDUAL_HEADER_HEIGHT;
    return height;
}

export const UNCLASS_HEADER_HEIGHT = isLowside() ? 16 : 0;
export const HEADERS_HEIGHT = (exercise, includeExerciseData, motds) => UNCLASS_HEADER_HEIGHT + OPT_HEADER_HEIGHT(exercise, includeExerciseData, motds);